import { ITourStep } from "training/types";

import { MODULE_1 } from "./module1";
import { MODULE_2 } from "./module2";
import { MODULE_3 } from "./module3";
import { MODULE_4 } from "./module4";
import { MODULE_5 } from "./module5";
import { MODULE_6 } from "./module6";

export { CURRICULUM_VERSION } from "./version";

/** Every step in tour order. 4.10 (Direct Pay) is Module 4's last step, on the hospital view (see module4.ts). */
export const CURRICULUM: ITourStep[] = [
  ...MODULE_1,
  ...MODULE_2,
  ...MODULE_3,
  ...MODULE_4,
  ...MODULE_5,
  ...MODULE_6,
];
